<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponente
        :aplica-busqueda-fecha="true"
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla="datosTabla"
      :resource="resource"
      @_funcionExtra="getObtenerDatosBandeja"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponente>
  </div>
</template>

<script>
import BandejaComponente from "../components/bandejas/BandejaComponente.vue";
import Swal from "sweetalert2";

export default {
  name: "BandejaDoctorHallazgo",
  components: {
    BandejaComponente,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaFin: "",
    fechaIncio: "",
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    idPaciente: 0,
    datosTabla: [],
    encabezados: [
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaDoctorLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Doctor OG",
        sortable: true,
      },
      {
        key: "nombreSolcitante",
        label: "Solicitante",
        sortable: true,
      },
    ],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
        permiso: "BJ_01_pestana_pend",
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
        permiso: "BJ_01_pestana_proces",
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "BJ_01_pestana_fin",
      },
    ],
    icono: "fa fa-user-md",
    titulo: "OG",
    codigoTitulo: "DX_",
    subTitulo: "Bandeja OG sin SDI",
    resource: {
      idEstatusSolicitud: null,
    },
    idEstatusPestañaSeleccionada : 1,
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;

      const datos = {
        fechaIncio: this.fechaInicio,
        fechaFinal: this.fechaFin,
        idEmpleado: this.idEmpleado,
        intIdEstuatusSolicitud: intIdEstuatusSolicitud,
        idPaciente: this.idPaciente
      }

      this.$http
        .post(
          this.$api +
            "pti/bandeja/doctor/obtenerDatosBandejaHallazgos", datos
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.permiteCambiarDiagnosticador =
            response.data.data.blnPermiteEditar;
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
          this.datosTabla = response.data.data.listaResultados;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        });
    },
    getCifrasPorEstatus() {
      this.showAlert();
      const datos = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idClinica: this.idClinica,
        idPaciente: this.idPaciente
      }

      this.$http
        .post(
          this.$api +
            "pti/bandeja/doctor/cifrasPorEstatus", datos
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezados;
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[1].layoutTabla = this.encabezados;
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[2].layoutTabla = this.encabezados;
              }
            });
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });
    }, //  ----------------------------

    actualizarFecha(fechaInicio, fechaFin, idPaciente) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },

    

    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

  },
  mounted() {
    this.getObtenerDatosBandeja(1);

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    var dia1 = new Date();
    dia1.setDate(dia1.getDate() - 3);
    dia1.setHours(0, 0, 0, 0);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },
  computed: {},
};
</script>
